import { DownsellStep } from "@redotech/redo-flows-common/steps";
import { useTranslation } from "@redotech/redo-i18n";
import DownLeftIcon from "@redotech/redo-icons/arrow-narrow-down-left_filled.svg";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Handle, Position } from "@xyflow/react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";

export interface DownsellNodeData {
  step: PartialWithRequiredType<DownsellStep>;
  deleteElements: (id: string) => void;
}

export function DownsellNode(data: {
  id: string;
  data: DownsellNodeData;
  selected?: boolean | undefined;
}) {
  const { t } = useTranslation();

  return (
    <>
      <Handle position={Position.Top} type="target" />
      <BaseNode
        icon={
          <RedoFeaturedIcon color="success" Icon={DownLeftIcon} size="xs" />
        }
        onDelete={() => data.data.deleteElements(data.id)}
        selected={data.selected}
        step={data.data.step}
        title={data.data.step.name ?? t("Downsell")}
      />
      <Handle position={Position.Bottom} type="source" />
    </>
  );
}
